export default {
  props: {
    stickyTableHead: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      ro: null,
      startTableCoordinates: 0,
      thsWidth: {},
      allWidth: {},
      isObserving: false
    }
  },
  created () {
    if (this.stickyTableHead) {
      window.addEventListener('scroll', this.handleScroll)
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.myEventHandler)
    this.allWidth = {}
    this.thsWidth = {}
  },
  mounted () {
    this.ro = new ResizeObserver(this.myEventHandler)
    this.startObserving()
  },
  computed: {
    getCoordinates () {
      if (this.startTableCoordinates > 0) {
        return 0
      }

      return Math.abs(this.startTableCoordinates)
    }
  },
  methods: {
    handleScroll () {
      this.startTableCoordinates = this.$refs.tableContain.getBoundingClientRect().top
    },
    calcWidth (index) {
      return this.allWidth[index] + 'px'
    },
    getAllTheadWidth (extraClass) {
      let theadEl
      if (extraClass) {
        theadEl = document.querySelectorAll(`.main-head.${extraClass} th`)
      } else {
        theadEl = document.querySelectorAll('.main-head th')
      }
      Array.from(theadEl).forEach((item, i) => {
        this.allWidth[extraClass ? extraClass + i : i] = item.getBoundingClientRect().width
      })

      this.$forceUpdate()
    },
    getThWidth () {
      setTimeout(() => {
        const currentRefs = this.$refs

        for (const key in currentRefs) {
          if (!currentRefs[key]) {
            continue
          }
          if (currentRefs[key][0] && key.startsWith('userth')) {
            this.thsWidth[key] = currentRefs[key][0].getBoundingClientRect().width + 20
          }
          if (key.startsWith('th')) {
            this.thsWidth[key] = currentRefs[key].getBoundingClientRect().width + 20
          }
        }
      }, 10)

      this.$forceUpdate()
    },
    myEventHandler () {
      this.getAllTheadWidth()
      this.getThWidth()
      this.$forceUpdate()
    },
    startObserving () {
      if (this.ro && this.$refs.tableContain && !this.isObserving) {
        this.ro.observe(this.$refs.tableContain)
        this.getAllTheadWidth()
        this.isObserving = true
      }
    }
  }
}
